import axios from "axios";
import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ButtonBack } from "../../Components/ButtonBack";
import { Toaster, toast } from "react-hot-toast";
import style from "./style.module.css";

export function EditBeer() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    ibu: "",
    country: "",
    style: "",
    abv: "",
    description: "",
    ideal_temp: "",
    year: "",
    pair: "",
  });

  useEffect(() => {
    async function fetchBeer() {
      try {
        const response = await axios.get(
          `https://ironrest.herokuapp.com/mocked-beers/${id}`
        );
        setForm({ ...response.data });
        console.log(response.data);
      } catch (error) {
        console.log(error);
      }
    }
    fetchBeer();
  }, [id]);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
    console.log(form);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const clone = { ...form };

      delete clone._id;

      await axios.put(
        `https://ironrest.herokuapp.com/mocked-beers/${id}`,
        clone
      );
      navigate("/beer-list");
    } catch (err) {
      console.log(err);
    }
  }

  async function handleDelete() {
    if (
      window.confirm(
        "Tem certeza que deseja apagar? Nosso site é aberto para colaboração, alguém poderá ver essa cerveja e provar e ter uma otima noite de jantar nao seja bobo nao apague a cervejinha alheia colabore"
      ) === true
    ) {
      try {
        await axios.delete(`https://ironrest.herokuapp.com/mocked-beers/${id}`);
        navigate("/beer-list");
      } catch (error) {
        console.log(error);
      }
    } else {
      return;
    }
  }

  return (
    <>
      <div className={style.editbeer}>
        <Toaster />
        {/* <ButtonBack /> */}
        <Link to={`/beer-detail/${id}`}>
          <button className={`btn-warning ${style.btn1}`}>Voltar</button>
        </Link>
        <div className={style.textblock}>
          <h1>Editar informações:</h1>
          <form className={style.form} onSubmit={handleSubmit}>
            <label htmlFor="img-input">Adicione o logo da cerveja! (URL)</label>
            <input
              id="img-input"
              value={form.logo}
              type="string"
              name="logo"
              onChange={handleChange}
              required
            />
            <label htmlFor="name-input">Nome da cerveja</label>
            <input
              id="name-input"
              value={form.name}
              type="string"
              name="name"
              onChange={handleChange}
              required
            />
            <label htmlFor="ibu-input">
              IBU da cerveja (Índice de amargor)
            </label>
            <input
              id="ibu-input"
              value={form.ibu}
              type="number"
              name="ibu"
              onChange={handleChange}
              max="9999"
              min="0"
              required
            />
            <label htmlFor="country-input">Em que país foi criada?</label>
            <input
              id="country-input"
              value={form.country}
              type="string"
              name="country"
              onChange={handleChange}
              required
            />
            <label htmlFor="style-input">Estilo da cerveja</label>
            <input
              id="style-input"
              value={form.style}
              type="string"
              name="style"
              onChange={handleChange}
              required
            />
            <label htmlFor="abv-input">ABV (Teor alcóolico)</label>
            <input
              id="abv-input"
              value={form.abv}
              type="string"
              name="abv"
              onChange={handleChange}
              required
              //   max="100"
            />
            <label htmlFor="description-input">
              Comente um pouco sobre a cerveja
            </label>
            <input
              className={style.comment}
              id="description-input"
              value={form.description}
              type="string"
              name="description"
              onChange={handleChange}
              required
            />
            <label htmlFor="year-input">Em qual ano foi criada?</label>
            <input
              id="year-input"
              value={form.year}
              type="number"
              name="year"
              onChange={handleChange}
              max="2022"
              required
            />
            <label htmlFor="pair-input">Harmoniza bem com?</label>
            <input
              id="pair-input"
              value={form.pair}
              type="string"
              name="pair"
              onChange={handleChange}
              required
            />
            <button className="btn btn-warning mt-3" type="submit">
              Confirmar alterações
            </button>
            <button className="btn btn-danger mt-3" onClick={handleDelete}>
              Excluir cerveja
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
